authorizationInterceptor.$inject = ['$q', '$injector'];
export function authorizationInterceptor($q, $injector) {
	return {
		responseError: async function (response) {
			const authService = $injector.get('mx.shell.AuthService');

			if (response.status === 401 || response.status === 406) {
				await authService.logout();
			}
			return $q.reject(response);
		},

		request: async function (config) {
			const authService = $injector.get('mx.shell.AuthService');
			const token = await authService.getToken();
			if (token) {
				config.headers.Authorization = config.headers.Authorization || `Bearer ${token}`;
			}
			return config;
		},
	};
}
